import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useAssetsFieldsValuesState = () => React.useContext(Context)
export const useAssetsFieldValues = () => useAssetsFieldsValuesState()?.assets

/* TODO: Improve this limit. Maybe we can separate the serviceCodes
find the types associated and use their ids to filter assets*/
const QUERY = gql`
  query Asset {
    assets(limit: 99999999) {
      id
      name
      type {
        id
        name
      }
      fieldValues {
        id
        value
        field {
          id
          name
        }
      }
    }
  }
`

const AssetsFieldValuesLoader = ({ children }) => {
  let { data, ...state } = useQuery(QUERY, {
    client: placesClient
  })

  return (
    <StatePresenter {...state} noEmptyMessage>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetsFieldValuesLoader
